import { getCsrfToken } from "@/app/_utils/csrf";

class FileService {
  static instance: FileService;

  async uploadImage(file: string): Promise<{ url: string }> {
    const res = await fetch(
      `${import.meta.env.VITE_API_BASE_URL}file/upload-image/`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({ file }),
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCsrfToken(),
        },
      }
    );

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      const message =
        typeof data.detail === "string"
          ? data.detail
          : "Image upload failed";
      throw new Error(message);
    }

    if (!data.url) {
      throw new Error("Image upload failed");
    }

    return { url: data.url };
  }
}

export default new FileService();
